export default __webpack_public_path__ + "static/media/012-line-white.9cd94c8c.svg";